import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { SecurityClassificationDto } from '@cradua/data';

@Component({
  selector: 'cradua-security-classification',
  templateUrl: './security-classification.component.html',
  styleUrls: ['./security-classification.component.scss'],
})
export class SecurityClassificationComponent implements OnChanges {
  securityclassificationForm: FormGroup;
  securityclassificationFormArray: FormGroup;
  control = new FormControl();
  @Input() securityclassifications: SecurityClassificationDto[];
  @Input() routeAnimationsElements: any;
  @Output() securityclassification = new EventEmitter<
    SecurityClassificationDto[]
  >();
  @Output() deleteSecurityClassificationEvent = new EventEmitter<any>();

  selectedSecurityClassification: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createSecurityClassificationForm();
  }

  createSecurityClassificationForm() {
    this.securityclassificationForm = this.fb.group({
      SecurityClassificationName: ['', Validators.required],
      SecurityCodeName: [''],
      Description: [''],
      id: null,
    });
    this.securityclassificationFormArray = this.fb.group({
      SecurityClassifications: this.fb.array([]),
    });
    this.setSecurityClassification();
  }

  // method to display securityclassifications
  setSecurityClassification() {
    const control = this.securityclassificationFormArray.controls
      .SecurityClassifications as FormArray;
    this.securityclassifications.forEach((e) => {
      control.push(
        this.fb.group({
          SecurityClassificationName: e.SecurityClassificationName,
          Description: e.Description,
          SecurityCodeName: e.SecurityCodeName,
          id: e.id,
        })
      );
    });
  }

  // method to add SecurityClassification
  addSecurityClassification(value: SecurityClassificationDto) {
    const control = this.securityclassificationFormArray.controls
      .SecurityClassifications as FormArray;
    control.insert(
      0,
      this.fb.group({
        SecurityClassificationName: value.SecurityClassificationName,
        Description: value.Description,
        SecurityCodeName: value.SecurityCodeName,
        id: null,
      })
    );
  }

  selectSecurityClassification(value) {}

  // method to delete securityclassification from arrary list
  deleteSecurityClassification(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.securityclassificationFormArray.controls
          .SecurityClassifications as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.securityclassifications.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.securityclassifications[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SecurityClassificationDto) {
    if (this.securityclassificationForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.securityclassificationFormArray
        .get('SecurityClassifications')
        ['controls'][this.selectedIndex].patchValue({
          SecurityClassificationName: formValue.SecurityClassificationName,
          SecurityCodeName: formValue.SecurityCodeName,
          Description: formValue.Description,
        });
    } else {
      this.addSecurityClassification(formValue);
    }
    this.selectedIndex = null;
    this.securityclassificationForm.reset();
  }

  onEdit(index, value: SecurityClassificationDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.securityclassificationForm.patchValue({
      SecurityClassificationName: value.SecurityClassificationName,
      SecurityCodeName: value.SecurityCodeName,
      Description: value.Description,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.securityclassificationForm.reset();
  }

  onSubmit(formValue: SecurityClassificationDto[]) {
    this.securityclassification.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteSecurityClassificationEvent.emit(this.filteredDelete);
    }
  }
}
